var React = require('react');

function LinkedinCircle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a,.d{fill:none;}.a{stroke:#1d2340;}.b{fill:#1d2340;}.c{stroke:none;}")),React.createElement("g",{"className":"a","key":1},[React.createElement("circle",{"className":"c","cx":"16","cy":"16","r":"16","key":0}),React.createElement("circle",{"className":"d","cx":"16","cy":"16","r":"15.5","key":1})]),React.createElement("path",{"className":"b","d":"M2.686,12H.2V3.989H2.686ZM1.441,2.9A1.448,1.448,0,1,1,2.882,1.442,1.453,1.453,0,0,1,1.441,2.9ZM12,12H9.515V8.1c0-.929-.019-2.121-1.294-2.121-1.294,0-1.492,1.01-1.492,2.055V12H4.245V3.989H6.631V5.082h.035A2.614,2.614,0,0,1,9.019,3.788C11.537,3.788,12,5.446,12,7.6V12Z","transform":"translate(10 9.999)","key":2})]);
}

LinkedinCircle.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = LinkedinCircle;

LinkedinCircle.default = LinkedinCircle;
